export default "__VITE_PUBLIC_ASSET__0b54d4b0__"